import { Injectable } from "@angular/core";
import { HttpclientService, UserService, UserInfo } from "../../../shared";
import { Subject } from "rxjs";
import { LoginChangePasswordRequest } from "../password-reset-by-admin/ChangePasswordRequest";
import { MFAAuthRequest } from "./MFAAuthRequest";
import { LoginStep1Request, LoginStep2Request, LoginStep3Request, RegisterMFARequest } from "./LoginStepInfo";
import { SetEmailRequest } from "../set-email-dialog/SetEmailRequest";
import { StringRequest } from "./StringRequest";

import * as moment from "moment";
import { EndpointLoginStep1Request } from "./EndpointLoginStep1Request";
import { EndpointLoginStep2Request } from "./EndpointLoginStep2Request";
import { SuPasswordResetUpdatePasswordRequest } from "./SuPasswordResetUpdatePasswordRequest";

@Injectable()
export class LoginService {
	constructor(private httpclientService: HttpclientService, private userService: UserService) {}

	validateUser(username, password) {
		var data = {
			Username: username,
			Password: password,
			grant_type: "password",
		};

		var postResult$ = new Subject();

		var getToken$ = this.httpclientService.post("api/token/auth", data);
		getToken$.subscribe(
			(response) => {
				var thisResponse: any = response;

				// console.log("Auth Response");
				// console.log(thisResponse);

				var user = new UserInfo();
				user.c_date = moment(new Date()).format("MM/DD/YYYY");
				user.isLoggedIn = true;
				user.token = thisResponse.access_token;
				user.refresh_token = thisResponse.refresh_token;
				user.token_expiration = thisResponse.expiration;
				this.userService.setCurrentUser(user);

				var current$ = this.httpclientService.post("Authentication/CurrentUserGet", null);
				current$.subscribe((responseUser) => {
					var userinfo: any = responseUser;
					user.userID = userinfo.UserId;
					user.personID = userinfo.PersonId;
					user.userName = userinfo.UserName;
					user.UserLevelID = userinfo.UserLevelID;
					user.HasClassRoomAttendanceAccess = userinfo.HasClassRoomAttendanceAccess;
					user.HasPrintAccess = userinfo.HasPrintAccess;
					user.HasVisitorAccess = userinfo.HasVisitorAccess;

					this.userService.setCurrentUser(user);
					postResult$.next(user);
				});

				this.userService.setCurrentUser(null);
			},
			(error) => {
				postResult$.error(error);
			}
		);

		return postResult$;
	}

	UserForgotPassword(Username) {
		var postResult$ = new Subject();
		var url = "api/token/forgotpassword";

		var data = {
			Username: Username,
		};

		var promise$ = this.httpclientService.post(url, data);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	UserForgotMFA(Username) {
		var postResult$ = new Subject();
		var url = "api/token/forgotmfa";

		var data = {
			Username: Username,
		};

		var promise$ = this.httpclientService.post(url, data);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	LoadPasswordPreferenceList() {
		var postResult$ = new Subject();
		var url = "api/token/districtpasswordprefs";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	DecryptLink(CipherText) {
		var postResult$ = new Subject();
		var url = "api/token/decryptlink";

		var data = {
			Username: CipherText,
		};

		var promise$ = this.httpclientService.post(url, data);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	ForgotUsername(e) {
		var postResult$ = new Subject();
		var url = "api/token/forgotusername";

		var data = {
			Username: e,
		};

		var promise$ = this.httpclientService.post(url, data);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	CheckExpired(UserID) {
		var postResult$ = new Subject();
		var url = "api/token/CheckExpired?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	CheckResetByAdmin(UserID) {
		var postResult$ = new Subject();
		var url = "api/token/CheckResetByAdmin?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	ChangePassword(parms: LoginChangePasswordRequest) {
		var postResult$ = new Subject();
		var url = "api/token/ChangePassword";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	LoadDistrictSecurityPreferenceList() {
		var postResult$ = new Subject();
		var url = "api/token/LoadDistrictSecurityPreferenceList?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MFACheckRegistered(UserID) {
		var postResult$ = new Subject();
		var url = "api/token/MFACheckRegistered?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	CheckMFACode(parms: MFAAuthRequest) {
		var postResult$ = new Subject();
		var url = "api/token/CheckMFACode";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SelectMFAPreference(UserID) {
		var postResult$ = new Subject();
		var url = "api/token/SelectMFAPreference?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	GetDefaultPage(UserID) {
		var postResult$ = new Subject();
		var url = "api/token/GetDefaultPage?UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	LoginPageInfoSelect() {
		var postResult$ = new Subject();
		var url = "api/token/LoginPageInfoSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	LoginStep1(parms: LoginStep1Request) {
		var postResult$ = new Subject();
		var url = "api/token/LoginStep1";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	RegisterForMFA(parms: RegisterMFARequest) {
		var postResult$ = new Subject();
		var url = "api/token/RegisterForMFA";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	LoginStep2(parms: LoginStep2Request) {
		var postResult$ = new Subject();
		var url = "api/token/LoginStep2";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	LoginStep3(parms: LoginStep3Request) {
		var postResult$ = new Subject();
		var url = "api/token/LoginStep3";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	ServerNameSelect() {
		var postResult$ = new Subject();
		var url = "api/token/ServerNameSelect?";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	SetEmail(parms: SetEmailRequest) {
		var postResult$ = new Subject();
		var url = "api/token/SetEmail";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	UserHasEmail(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "api/token/UserHasEmail";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	PasswordInstructionSelect() {
		var postResult$ = new Subject();
		var url = "api/token/PasswordInstructionSelect";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	IdentityProviderSelectList() {
		var postResult$ = new Subject();
		var url = "api/token/IdentityProviderSelectList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	SuPasswordResetRequest(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "api/token/SuPasswordResetRequest";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	EndpointLoginStep1(parms: EndpointLoginStep1Request) {
		var postResult$ = new Subject();
		var url = "api/token/EndpointLoginStep1";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	EndpointLoginStep2(parms: EndpointLoginStep2Request) {
		var postResult$ = new Subject();
		var url = "api/token/EndpointLoginStep2";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	SuPasswordResetInfoSelect(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "api/token/SuPasswordResetInfoSelect";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	SuPasswordResetUpdatePassword(parms: SuPasswordResetUpdatePasswordRequest) {
		var postResult$ = new Subject();
		var url = "api/token/SuPasswordResetUpdatePassword";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	SuMFAResetRequest(parms: StringRequest) {
		var postResult$ = new Subject();
		var url = "api/token/SuMFAResetRequest";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}
}
